import { NgModule } from '@angular/core';
import { PropertyDivisionFormPfComponent } from './property-division-form-pf/property-division-form-pf.component';
import { PropertyDivisionStagePfComponent } from './property-division-stage-pf/property-division-stage-pf.component';
import { PropertyDivisionSuccessPfComponent } from './property-division-success-pf/property-division-success-pf.component';
import { PropertyDivisionModule } from '../property-division.module';
import { SharedComponentsModule } from '../components/shared-components/shared-components.module';

@NgModule({
  declarations: [
    PropertyDivisionFormPfComponent,
    PropertyDivisionStagePfComponent,
    PropertyDivisionSuccessPfComponent,
  ],
  imports: [PropertyDivisionModule, SharedComponentsModule],
  exports: [],
})
export class PropertyDivisionPfModule {}
